import React from 'react';
import useFormState from '../form-provider/use-form-state';

interface UploadProps {
    name: string
    placeholder?: string
    required?: boolean,
}

const Upload = ({
    name,
    placeholder,
    required,
}: UploadProps): JSX.Element => {
    const formProvider = useFormState<File>({
        name,
        validators: {
            required,
        },
    });

    /*
    * TODO: More complete implementation later on
    * */

    return (
        <input
            type="file"
            placeholder={placeholder || 'Upload'}
            name={name}
            onChange={(event) => {
                if (event.target.files?.[0]) {
                    formProvider.setValue(event.target.files?.[0]);
                } else {
                    formProvider.setValue(null);
                }
            }}
        />
    );
};

export default Upload;
